import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, MessageCircle, FileText } from "lucide-react";
import { company } from "../data/company";
import { trackClick } from "../utils/analytics";

export const StickyQuoteButton = () => {
  const loc = useLocation();
  // Hide on dedicated full-screen flows that have their own CTA
  if (loc.pathname.startsWith("/offerte")) return null;
  if (loc.pathname.startsWith("/configurator")) return null;

  const isModern = true;

  return (
    <>
      {/* Desktop: middle-right vertical bar — bewust beperkt tot de 2 belangrijkste acties */}
      <div className="hidden md:flex fixed right-0 top-1/2 -translate-y-1/2 z-40 flex-col gap-2" data-testid="sticky-quote-desktop">
        <Link
          to="/offerte"
          className={`flex items-center gap-2 px-4 py-3 font-semibold text-xs tracking-[0.18em] uppercase transition-colors ${
            isModern
              ? "bg-m-orange text-white hover:bg-m-orange-hover shadow-soft"
              : "bg-koning-gold text-koning-bg hover:bg-koning-goldHover"
          }`}
          style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}
          data-testid="sticky-cta-offerte"
        >
          <FileText size={14} /> Offerte Aanvragen
        </Link>
        <a
          href={company.phoneHref}
          onClick={() => trackClick("phone", "sticky-desktop")}
          className={`flex items-center justify-center w-12 h-12 transition-colors ${
            isModern
              ? "bg-white border border-m-border text-m-navy hover:border-m-orange hover:text-m-orange shadow-soft"
              : "bg-koning-surface border border-koning-border text-white hover:border-koning-gold hover:text-koning-gold"
          }`}
          aria-label="Bel direct"
          data-testid="sticky-cta-phone"
        >
          <Phone size={18} />
        </a>
      </div>

      {/* Mobile: bottom bar */}
      <div className={`md:hidden fixed bottom-0 left-0 right-0 z-40 pb-[env(safe-area-inset-bottom)] ${
        isModern ? "bg-white border-t border-m-border-soft shadow-[0_-8px_24px_-8px_rgba(8,24,42,0.12)]" : "bg-koning-bg border-t border-koning-border"
      }`} data-testid="sticky-quote-mobile">
        <div className={`grid grid-cols-3 divide-x ${isModern ? "divide-m-border-soft" : "divide-koning-border"}`}>
          <a
            href={company.phoneHref}
            onClick={() => trackClick("phone", "sticky-mobile")}
            className={`flex items-center justify-center gap-2 py-4 text-xs tracking-[0.16em] uppercase font-semibold ${
              isModern ? "text-m-navy" : "text-white"
            }`}
            data-testid="sticky-cta-phone-mobile"
          >
            <Phone size={15} className={isModern ? "text-m-orange" : "text-koning-gold"} /> Bel
          </a>
          <a
            href={company.whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackClick("whatsapp", "sticky-mobile")}
            className={`flex items-center justify-center gap-2 py-4 text-xs tracking-[0.16em] uppercase font-semibold ${
              isModern ? "text-m-navy" : "text-white"
            }`}
            data-testid="sticky-cta-whatsapp-mobile"
          >
            <MessageCircle size={15} className={isModern ? "text-m-orange" : "text-koning-gold"} /> Chat
          </a>
          <Link
            to="/offerte"
            className={`flex items-center justify-center gap-2 py-4 text-xs tracking-[0.16em] uppercase font-bold shadow-[inset_0_2px_0_rgba(255,255,255,0.15)] ${
              isModern ? "bg-m-orange text-white active:bg-m-orange-hover" : "bg-koning-gold text-koning-bg"
            }`}
            data-testid="sticky-cta-offerte-mobile"
          >
            <FileText size={15} /> Offerte
          </Link>
        </div>
      </div>
    </>
  );
};
